import ApiConstant from "../../constants/api.constants";
import Token from "../../interfaces/authorization/token";
import { LoginModel } from "../../models/login-model";
import { UserModel } from "../../models/user-model";
import Helpers from "../../utils/helpers";
import api from "../api";
import TokenService from "./token.service";
import { TokenRefreshModel } from "../../models/authentication/token-refresh-model";
import UserService from "../user/user.service";
import MenuService from "../menu/menu.service";
import ProductService from "../products/products.service";
import CategoryService from "../category/category.service";

const logout = () => {
  // Clear all caches before removing user data
  MenuService.clearMenuCache();
  ProductService.clearProductCache();
  CategoryService.clearCategoryCache();
  TokenService.removeUser();
};

const isUserLoggedIn = () => {
  return TokenService.getUser() != null;
};

const login = async (login: LoginModel) => {
  return await api
    .post(
      ApiConstant.getToken,
      { userId: login.userId, password: login.password },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    )
    .then(async function (response: any) {
      if (response) {
        let data: Token = response.data;

        TokenService.addOrUpdateLocalRefreshToken(data?.refresh_token);
        TokenService.addOrUpdateLocalAccessToken(data?.access_token);
        await UserService.getCurrentUser();
        return data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error?.response?.data;
    });
};

const register = async (user: UserModel) => {
  return await api
    .post(ApiConstant.userRegister, user, {
      headers: {
        "content-type": "application/json",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
};

const createUser = async (user: UserModel) => {
  return await api
    .post(ApiConstant.createUser, user, {
      headers: {
        "content-type": "application/json",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
};

const checkUserExists = async (phoneNumber: string) => {
  try {
    const tenantGuid = process.env.REACT_APP_TENAT_ID ?? "1"; // Default to 1 if not set
    const response = await api.get(
      `${ApiConstant.checkUserExists}/${phoneNumber}?tenantGUID=${tenantGuid}`
    );
    return response.data;
  } catch (error) {
    Helpers.ConsoleLog(error, "error");
    return { exists: false };
  }
};

const getUserById = async (userId: number) => {
  try {
    const response = await api.get(`${ApiConstant.getUserById}/${userId}`);
    return response.data;
  } catch (error) {
    Helpers.ConsoleLog(error, "error");
    return null;
  }
};

const refreshTokenFromServer = async () => {
  var refreshModel: TokenRefreshModel = {
    accessToken: TokenService.getLocalAccessToken(),
    refreshToken: TokenService.getLocalRefreshToken(),
  };
  await api
    .post(ApiConstant.getRefreshToken, refreshModel, {
      headers: {
        "content-type": "application/json",
      },
    })
    .then(function (response: any) {
      if (response) {
        let data: Token = response.data;
        TokenService.addOrUpdateLocalRefreshToken(data?.refresh_token);
        TokenService.addOrUpdateLocalAccessToken(data?.access_token);
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      // Clear all caches on refresh token failure
      MenuService.clearMenuCache();
      ProductService.clearProductCache();
      CategoryService.clearCategoryCache();
    });
};

const AuthService = {
  logout,
  isUserLoggedIn,
  refreshTokenFromServer,
  login,
  register,
  createUser,
  checkUserExists,
  getUserById
};

export default AuthService;
